import React, { useContext, useEffect, useState } from 'react'
import { Input, Spin, App } from "antd";
import { API, Enum, Regex } from "../../../resources/constants"
import language from "../../../resources/languages/fa_IR"

// Contexts
import AxiosContext from "../../../contexts/axios";

// Interfaces
import { AxiosError } from "../../../interfaces/axios"
import { AntTableParams } from "../../../interfaces/ant"
import type { TablePaginationConfig } from 'antd/es/table'

const { Pages: { UserManagement: { Permission: PermissionLanguage } }, Share, Validation, Message: MessageLanguage } = language
const { USER_MANAGEMENT_PERMISSION_ID, USER_MANAGEMENT_PERMISSION_CREATE, USER_MANAGEMENT_PERMISSION_UPDATE } = API
const { isPermission } = Regex
const { Message } = Enum

export default function CURecord(props: { Form: any, form: any, record: { id: string }|null, getPermissions: (params: AntTableParams) => void, pagination: TablePaginationConfig, sort: string|false|null|undefined }) {
    const { Form, form, record, getPermissions, pagination, sort } = props

    const { axios } = useContext(AxiosContext)
    const [loadingRecord, setLoadingRecord] = useState<boolean>(true);
    const { message } = App.useApp();

    useEffect(() => {
        form.resetFields()
        initialAPI().then(response => response)
    }, []);

    const initialAPI = async () => {
        await getRecord()
    }

    const getRecord = async () => record ? axios.get(USER_MANAGEMENT_PERMISSION_ID + record.id).then((response: { data: {} }) => {
        const { data: permission } = response
        form.setFieldsValue(permission)
        setLoadingRecord(false)
    }).catch((error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response )
    }) : setLoadingRecord(false)

    const onFinish = ((user: {}) => {
        setLoadingRecord(true)
        if (record) {
            axios.patch(USER_MANAGEMENT_PERMISSION_UPDATE + record.id, user).then((response: {}) => {
                message.success(MessageLanguage[Message.UPDATE_RECORD]).then(response => response)
                setLoadingRecord(false)
                const { current, pageSize } = pagination
                getPermissions({ page: current, limit: pageSize, sort })
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response)
                setLoadingRecord(false)
            })
        } else {
            axios.post(USER_MANAGEMENT_PERMISSION_CREATE, user).then((response: {}) => {
                message.success(MessageLanguage[Message.CREATE_RECORD]).then(response => response)
                form.resetFields()
                setLoadingRecord(false)
                const { current, pageSize } = pagination
                getPermissions({ page: current, limit: pageSize, sort })
            }).catch((error: AxiosError) => {
                const { response: { data } } = error;
                // @ts-ignore
                message.error(MessageLanguage[data.message]).then(response => response)
                setLoadingRecord(false)
            })
        }
    })


    return (
        <Spin spinning={loadingRecord} tip={Share.loading} size="large">
            <Form form={form} name="cu-record" onFinish={onFinish} style={{ margin: '25px 0 10px 0'}}>
                <Form.Item
                    label={PermissionLanguage.name}
                    name="name"
                    hasFeedback
                    rules={[
                        { required: true, message: `${PermissionLanguage.name} ${Validation.required}` },
                        { pattern: isPermission, message: Validation.pattern },
                    ]}
                >
                    <Input placeholder={PermissionLanguage.name} />
                </Form.Item>
                <Form.Item
                    label={PermissionLanguage.caption}
                    name="caption"
                    hasFeedback
                    rules={[
                        { required: true, message: `${PermissionLanguage.caption} ${Validation.required}` },
                        { min: 3, message: `${PermissionLanguage.caption} ${Validation.min} 3 ${Validation.length}` },
                        { max: 150, message: `${PermissionLanguage.caption} ${Validation.max} 150 ${Validation.length}` },
                    ]}
                >
                    <Input.TextArea placeholder={PermissionLanguage.caption} />
                </Form.Item>
        </Form>
        </Spin>
    )
}
